import { connect } from 'react-redux';
import { usersListActions, userConatctsActions } from 'Actions';
import UserDetails from 'Components/Users/UserDetails';

function mapStatetoProps(state){
    return{
        usersList: state.usersList.usersList,
        //userContactsList: state.userContactsList.userContactsList,
    }
}
const mapDispatchtoProps = {
    fetchUsersList: usersListActions.fetchUsersList,
    //fetchUserContacts: userConatctsActions.fetchUserContacts
}

export default connect(mapStatetoProps,mapDispatchtoProps)(UserDetails)